import React from "react";
import { Grid } from "@material-ui/core";
import { InputTextMaster, InputOptionMaster } from "App/Component/ui";

import { isNull } from "App/utils/helpers";
import { useSelector } from "react-redux";
import { messageError } from "utils/all";

export default function FormAsuransi({ formData, setFormData, handleChanges }) {
  const master = useSelector(({ master }) => master);

  return (
    <>
      <p className='fw-600 fs-12'>ASURANSI</p>
      <div className='mt-1'>
        <Grid container spacing={1}>
          <Grid item sm={3}>
            <InputOptionMaster
              name='company_id'
              label='PERUSAHAAN'
              id='company_id'
              withSearch={true}
              data={master.perusahaan.list_select}
              value={formData.company_id}
              labelValue={formData.company_name}
              error={true}
              message={messageError.required}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormData({
                    ...formData,
                    company_id: null,
                    company_name: "Pilih Perusahaan",
                  });
                } else {
                  setFormData({
                    ...formData,
                    company_id: e.value,
                    company_name: e.label,
                  });
                }
              }}
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
              name='insurance_id'
              label='ASURANSI'
              id='insurance_id'
              withSearch={true}
              data={master.asuransi.list_select}
              value={formData.insurance_id}
              labelValue={formData.insurance_name}
              error={true}
              message={messageError.required}
              onChange={(e) => {
                if (isNull(e)) {
                  setFormData({
                    ...formData,
                    insurance_id: null,
                    insurance_name: "Pilih Asuransi",
                  });
                } else {
                  setFormData({
                    ...formData,
                    insurance_id: e.value,
                    insurance_name: e.label,
                  });
                }
              }}
            />
          </Grid>

          <Grid item sm={3}>
            <InputTextMaster
              name='insurance_no'
              label='NO ASURANSI/BPJS'
              id='insurance_no'
              placeholder='No Asuransi/BPJS'
              value={formData.insurance_no}
              onChange={handleChanges("insurance_no")}
              error={true}
              message={"Selain umum, wajib diisi"}
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name='norujukan'
              label='NO RUJUKAN'
              id='norujukan'
              placeholder='No Rujukan'
              value={formData.norujukan}
              onChange={handleChanges("norujukan")}
              error={true}
              message={"Jika BPJS, wajib diisi"}
            />
          </Grid>
          {/* <Grid item sm={4}>
            <InputTextMaster
              name='nokontrol'
              label='NO KONTROL'
              id='nokontrol'
              placeholder='No Kontrol'
              value={formData.nokontrol}
              onChange={handleChanges("nokontrol")}
            />
          </Grid> */}
        </Grid>
      </div>
    </>
  );
}
